import api from '@/api/axios/main.api'

export const fetchJadwalWfa = () => {
  return api.get('v2/persuratan/jadwalwfo/unit')
}

export const fetchAllJadwalWfa = () => {
  return api.get('v2/persuratan/jadwalwfo/')
}
